import { FileInfoService, FileUploadService, metadefenderService } from '..';
import { SCAN_STATES, ERRORS } from '@mdc/constants';
import AdvancedOptions from '../advanced-options/AdvancedOptions';

class FileScanService {
    constructor(file, maxFileSizeUpload) {
        this.maxFileSizeUpload = maxFileSizeUpload;
        this.file = new FileInfoService(file, maxFileSizeUpload);
        this.onProgressCallback = function() {};
        this.onErrorCallback = function() {};
    }

    onProgress(callback) {
        this.onProgressCallback = callback;
    }

    _updateProgress(status, data) {
        const dataObj = Object.assign({
            percent: null,
            hash: null,
            data_id: null
        }, data);
        this.onProgressCallback(status, dataObj);
    }

    onError(callback) {
        this.onErrorCallback = callback;
    }

    _sendError(message, headers) {
        this.onErrorCallback(message, headers);
    }

    async scan() {
        const file = this.file;
        const fileUploadService = new FileUploadService(file, this.maxFileSizeUpload);

        if (!file.isValid()) {
            this._sendError(ERRORS.FILE_SIZE_EXCEEDED);
            return;
        }

        if (file.isEmpty()) {
            this._sendError(ERRORS.FILE_EMPTY);
            return;
        }

        fileUploadService.onError((error, headers) => {
            this._sendError(error, headers);
        });

        this._updateProgress(SCAN_STATES.CALCULATE_HASH);
        const hash = await file.getMd5();

        fileUploadService.onProgress((percent) => {
            if (percent < 100) {
                this._updateProgress(SCAN_STATES.UPLOAD, { percent });
            }
        });

        fileUploadService.onSuccess(({ data_id }) => {
            this._updateProgress(SCAN_STATES.UPLOAD_COMPLETE, { data_id });
        });

        // Scan w/o hash-lookup
        if (!AdvancedOptions.hasHeader('hash-lookup')) {
            try {
                fileUploadService.upload(file);
            } catch (err) {
                this._sendError(err.message);
            }

            return;
        }

        this._updateProgress(SCAN_STATES.SEARCH_HASH);

        try {
            const [hashResultPromise] = metadefenderService.hash.getResults({ hash });
            const hashResult = await hashResultPromise;
            const response = hashResult.data;

            // eslint-disable-next-line no-prototype-builtins
            if (response.hasOwnProperty('share_file') && !response.share_file) {
                // If the file is private we want to upload the file
                fileUploadService.upload(file);
            } else {
                // We already have the file just redirect to results
                this._updateProgress(SCAN_STATES.FOUND_HASH, { hash });
            }
        } catch (err) {
            const response = err.response;
            if (response && response.status === 404 && response.data && response.data.error && response.data.error.code === 404003) {
                // If not found upload the file
                fileUploadService.upload(file);
            } else if (response && response.status === 429 && response.data && response.data.error && response.data.error.code === 429000) {
                this._sendError(ERRORS.LIMIT_ERROR, response.headers);
                return;
            } else {
                const responseErrorMessage = response && response.data && response.data.error && response.data.error.message;
                this._sendError(responseErrorMessage || err.message);
            }
        }
    }

}

export default FileScanService;
